const google = window.google;
export default class GoogleMap {
	constructor() {
		this.map = null;
		this.mapMarkers = [];
	}

	init() {
		if ($('.google-map').length) {
			this.initMap();

			window.updateMapMarkers = this.updateMapMarkers;

			$(document).on('click', '.map-mobile-overlay, .close-card', () => {
				this.closeActiveMarker();
			});
		}
	}

	async initMap() {
		const { Map } = await google.maps.importLibrary('maps');
		const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
		const { LatLngBounds } = await google.maps.importLibrary('core');

		const map = new Map($('.google-map .google-map__container')[0], {
			zoom: 16,
			mapId: '36136f86441b3825151b1b7a',
			zoomControlOptions: {
				position: google.maps.ControlPosition.RIGHT_TOP
			},
			streetViewControlOptions: false,
			fullscreenControl: false
		});

		const bounds = new LatLngBounds();
		const mapMarkers = [];

		const events = $('.google-map__markers .marker');

		for (const currentEvent of events) {
			const event = {
				title: $(currentEvent).data('event-id'),
				latLng: {
					lat: $(currentEvent).data('lat'),
					lng: $(currentEvent).data('lng')
				}
			};

			const eventMarker = new AdvancedMarkerElement({
				map,
				content: this.createMarker(currentEvent),
				position: event.latLng,
				title: event.title,
				zIndex: 0
			});

			bounds.extend(event.latLng);

			eventMarker.addListener('click', () => {
				this.toggleMarkerWindow(eventMarker, event);
			});

			mapMarkers.push(eventMarker);

			if (events.length === 1) {
				map.setCenter(event.latLng);
			}
		}

		map.addListener('zoom_changed', () => {
			if (map.zoom < 15) {
				$('.google-map-marker.active').css('z-index', '0');
				$('.google-map-marker.active').removeClass('active');
			}
		});

		if (events.length > 1) {
			map.fitBounds(bounds);
		}

		this.map = map;
		this.mapMarkers = mapMarkers;

		$('.google-map .google-map__container').addClass('active');
	}

	createMarker(event) {
		const content = document.createElement('div');
		content.classList.add('google-map-marker');
		content.innerHTML = $(event).find('.google-map-marker').html();
		content.setAttribute('data-event-id', $(event).data('event-id'));
		return content;
	}

	toggleMarkerWindow(markerView, event) {
		const active = markerView.content.classList.contains('active');

		this.closeActiveMarker();

		if (!active) {
			markerView.content.classList.add('active');
			markerView.zIndex = 1;

			$('.google-map__details-drawer').addClass('active');
			$('.google-map__details-drawer-container').html($('.google-map-marker.active .google-map-marker__event_detail').html());
			$('.map-mobile-overlay').fadeToggle();
		}

		// this.map.panTo(event.latLng);
		// this.map.panBy(0, -200);
	}

	closeActiveMarker() {
		this.mapMarkers.forEach(function(marker) {
			marker.zIndex = 0;
		});
		$('.google-map-marker.active').css('z-index', '0');
		$('.google-map-marker.active').removeClass('active');
		$('.google-map__details-drawer').removeClass('active');
		$('.map-mobile-overlay').fadeOut();
	}

	updateMapMarkers(events) {
		$('.google-map-marker.active').removeClass('active');
		$('.google-map-marker').hide();

		events.forEach(function (event) {
			$('.google-map-marker[data-event-id="' + event.ID + ' ' + event.title + '"]').show();
		});
	}

	destroy() {
		this.map = null;
	}
}
